import { useState } from "react";

const NZElectricDualSpec = () => {
    const [activeTab, setActiveTab] = useState("DIMENSIONS");
    const specifications = {
        "DIMENSIONS": [
            { label: "Overall Length", value: "3695mm" },
            { label: "Overall Width", value: "1590mm" },
            { label: "Overall Height(Inclusive of roof carry tray)", value: "2020mm" },
            { label: "Wheelbase", value: "2650mm" },
            { label: "Ground Clearance", value: "300mm" },
            { label: "Rear cargo deck (Internal dimensions)  (L x W x H)(mm)", value: "700mm x 1388mm x 300mm" },
        ],
        "MOTOR: 10KW FRONT": [
            { label: "MOTOR Type", value: "PM (Permanent magnet)" },
            { label: "Rated Voltage", value: "102-VAC" },
            { label: "Rated Power", value: "10kW" },
            { label: "Peak Power", value: "20kW" },
            { label: "Rated Current", value: "130A" },
            { label: "Peak Current", value: "350A" },
            { label: "Rated Speed", value: "3410 rpm" },
            { label: "Max Speed", value: "7500 rpm" },
            { label: "Rated Torque", value: "28N.M" },
            { label: "Max Torque", value: "85N.M" },
            { label: "Regenerative Braking", value: "Yes" },
            { label: "Brake System", value: "Hydraulic disc  with booster assist" },
            { label: "Cooling", value: "Water, with radiator and thermo fan" },
            { label: "Weight", value: "28kg±1KG" },
        ],
        "MOTOR: 15KW REAR": [
            { label: "MOTOR Type", value: "PM (Permanent magnet)" },
            { label: "Rated Voltage", value: "102-VAC" },
            { label: "Rated Power", value: "15kW" },
            { label: "Peak Power", value: "30kW" },
            { label: "Rated Current", value: "150A" },
            { label: "Peak Current", value: "350A" },
            { label: "Rated Speed", value: "3500 rpm" },
            { label: "Max Speed", value: "6000 rpm" },
            { label: "Rated Torque", value: "41N.M" },
            { label: "Max Torque", value: "110N.M" },
            { label: "Regenerative Braking", value: "Yes" },
            { label: "Brake System", value: "Hydraulic brake with booster assist" },
            { label: "Cooling", value: "Water, with radiator and thermo fan" },
            { label: "Waterproof Rating", value: "IP67" },
            { label: "Wiring Insulation Grade", value: "H" },
            { label: "Weight", value: "38kg±1KG" },
        ],
        "PRIMARY BATTERY": [
            { label: "Battery Type", value: "Lithium Iron Phosphate" },
            { label: "Battery Voltage(V)", value: "115" },           
            { label: "Capacity", value: "26.5kWh" },
            { label: "Cell Specification", value: "230AH, 3.2V" },
            { label: "Operating Temperature", value: "0°C to 55°C" },          
            { label: "Weight", value: "235kg" },           
            { label: "Maximum Range", value: "up to 160kms" },
        ],
        "CAPACITIES": [
            { label: "Maximum Load (Rear Cargo Tray)", value: "250kg" },
            { label: "Front Differential Oil", value: "0.65L" },
            { label: "Rear Differential Oil", value: "0.65L" },
        ],
        "SUSPENSION & BRAKES": [
            { label: "Front Suspension", value: "Independent Single A-Arm with MacPherson Strut" },
            { label: "Rear Suspension", value: "Independent Dual A-Arm with double coil springs" },
            { label: "Tyre Pressure (Front & Rear)", value: "30 psi" },
            { label: "Brakes", value: "Hydraulic disc, with booster assist" },
        ],
        "STRUCTURE": [
            { label: "Chassis", value: "All steel ladder design welded box section" },
            { label: "Anti-Corrosion Treatment", value: "Electrophoresis – chassis & all steel panels" },
            { label: "Net Weight", value: "1280kg" },
            { label: "Payload", value: "930kg" },
            { label: "Gross Weight", value: "2210kg" },
        ],
        "VEHICLE": [
            { label: "Secondary Battery", value: "12V, 35AH Lead acid" },
            { label: "DC/DC", value: "1000W, 144V" },
            { label: "OBC", value: "6.6kW, 144V" },
            { label: "Winch", value: "Front mounted electric winch (2000kg pulling capacity)" },
            { label: "Steering", value: "Power assisted rack and pinion" },
            { label: "Air Conditioning", value: "TU-DC2500-2 model only" },
        ]
    };
    return (       
        <div className="mt-[32px] mb-[32px]">
            <div className="custom-container px-[24px] md:px-[32px] lg:px-[48px] text-start mx-auto">
                <div className="max-w-[1400px] mx-auto w-full">
                    <h2 className="kuunari-bold text-2xl md:text-3xl lg:text-4xl leading-tight text-center">
                        Specifications Dual Cab, Dual Motor Model DC2500E-1 and TU-DC2500-2
                    </h2>
                    <div className="w-full mx-auto border border-gray-300 bg-gray-50 mt-[24px] rounded-lg shadow-lg">
                        <div className="flex flex-wrap  w-full border-b border-gray-300 bg-gray-200 p-2">
                            {Object.keys(specifications).map((tab) => (
                                <button
                                    key={tab}
                                    className={`flex items-center justify-center min-w-[100px] px-4 py-2 text-gray-700 cursor-pointer transition-all text-sm sm:text-base md:whitespace-nowrap ${
                                        activeTab === tab
                                          ? "bg-white border-b-4 border-blue-500 text-blue-600"
                                          : "hover:bg-gray-300"
                                      }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="p-[12px] sm:p-[16px] md:p-[24px]">
                            {specifications[activeTab].map((item, index) => (
                                <div
                                    key={index}
                                    className="grid grid-cols-12 items-center py-[8px] sm:py-[12px] border-b border-gray-200 last:border-none"
                                >
                                    <div className="col-span-5 sm:col-span-3 font-semibold text-gray-900 text-[12px] sm:text-[14px] md:text-[16px] text-left">
                                        {item.label}
                                    </div>
                                    <div className="col-span-2 sm:col-span-6 flex justify-center">
                                        <div className="w-full border-t border-gray-400 mx-[8px] sm:mx-[16px]"></div>
                                    </div>
                                    <div className="col-span-5 sm:col-span-3 text-gray-800 text-[12px] sm:text-[14px] md:text-[16px] text-right">
                                        {item.value}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default NZElectricDualSpec;
